module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-50-Classes-Active-d8fbef6fce109a382c22c133fdbe3914.png";